module.exports = __webpack_public_path__ + "static/media/bloco_criar_lead.7de7a9da.svg";